import { getElement } from './utils';
import EmblaCarousel from 'embla-carousel';
import { addPrevNextBtnsClickHandlers } from './components/EmblaCarouselArrowButtons';

export const bruniSliders = () => {
  const commonSliderOptions = {
    loop: true,
    breakpoints: {
      '(max-width: 1279px)': { align: 'start' }
    }
  };

  const initEmblaSlider = (sliderSelector, customOptions = {}) => {
    const slider = getElement(sliderSelector);
    if (!slider) return null;

    const viewport = slider.querySelector('.embla__viewport');
    const prevBtn = slider.querySelector('.embla__button--prev');
    const nextBtn = slider.querySelector('.embla__button--next');

    if (!viewport || !prevBtn || !nextBtn) return null;

    const mergedOptions = { ...commonSliderOptions, ...customOptions };

    const emblaApi = EmblaCarousel(viewport, mergedOptions);
    const removeClickHandlers = addPrevNextBtnsClickHandlers(emblaApi, prevBtn, nextBtn);

    emblaApi.on('destroy', removeClickHandlers);

    return emblaApi;
  };

  initEmblaSlider('.coupons_bruni_slider');
  initEmblaSlider('.reviews_bruni_slider');
};
